import { render, staticRenderFns } from "./ServiceRequestInspectionType.vue?vue&type=template&id=55f92a26&scoped=true"
import script from "./ServiceRequestInspectionType.vue?vue&type=script&lang=js"
export * from "./ServiceRequestInspectionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f92a26",
  null
  
)

export default component.exports